import { Controller } from '@hotwired/stimulus';

const SEARCH_DELAY_MS = 250;

// Searches the dashboard feed overview while typing. The form sits outside the Turbo Frame it
// updates, so its fields are synced from the URL whenever the frame or the page is restored.
export default class extends Controller {
    static targets = ['form', 'query', 'status'];

    connect() {
        // Back and forward restore a page snapshot that holds whatever was typed at the time
        const params = new URL(window.location.href).searchParams;

        this.queryTarget.value = params.get('q') ?? '';
        this.statusTarget.value = params.get('status') ?? '';
    }

    disconnect() {
        clearTimeout(this.timeout);
    }

    search() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.formTarget.requestSubmit(), SEARCH_DELAY_MS);
    }

    sync(event) {
        const url = new URL(event.target.src, window.location.href);

        this.statusTarget.value = url.searchParams.get('status') ?? '';
    }

    // Keeps empty fields out of the URL, so a cleared search reads /dashboard instead of /dashboard?status=&q=
    clean(event) {
        const { url } = event.detail;

        [...url.searchParams.entries()]
            .filter(([, value]) => '' === value)
            .forEach(([name]) => url.searchParams.delete(name));
    }

    scrollToTop() {
        this.element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}
